import numeral from 'numeral';

export default (columnKey, cellValue) => {
  let value;
  const classList = [];

  switch (columnKey) {
    case 'attribute': {
      value = cellValue;
      break;
    }
    default: {
      if (!cellValue) {
        value = null;
        break;
      }

      const valueAsNumber = numeral(cellValue);
      if (valueAsNumber.value() < 0) {
        classList.push('negative');
      }

      value = valueAsNumber.format('0.00%');
      break;
    }
  }

  return { value, classList };
};
